'use client'

import React from 'react'

import { containerClassName } from '@/components/Container'
import { HeadingBodySplitSection } from '@/components/HeadingBodySplitSection'
import { TrustBadges } from '@/components/Landing/TrustBadges'
import { splitLocationDescription } from '@/lib/locations/getLocationPageCopy'
import type { LocationPage } from '@/lib/mock/locationPages'
import { useMessages } from '@/lib/i18n/useMessages'
import { cn } from '@/utilities/ui'

type LocationIntroSectionProps = {
  location: LocationPage
}

export const LocationIntroSection: React.FC<LocationIntroSectionProps> = ({ location }) => {
  const copy = useMessages().location.intro

  return (
    <section aria-labelledby="location-intro-heading" className="w-full bg-cream">
      <div
        className={cn(
          containerClassName,
          'flex flex-col gap-10 px-4 py-12 lg:gap-10 lg:py-20',
        )}
      >
        <HeadingBodySplitSection
          bodyParagraphs={splitLocationDescription(location.description)}
          headingAfter={<TrustBadges className="mt-6 lg:mt-8" />}
          headingId="location-intro-heading"
          titleBeforeHighlight={copy.titleBeforeHighlight}
          titleHighlight={location.name}
        />
      </div>
    </section>
  )
}
